import ShowDataItem from './ShowDataItem'

export default ShowDataItem
